import { digger } from '@cbre/digger';
import { concatValuesBy, getTokensFromLocalStorage } from '@miq/utils';
import { map } from 'rxjs/operators';
import { ReportRecord } from '../../../../models/report.model';
import { sortAttributesByFieldId } from '../../utils/argument-sorting';
import { getWidthAndHeightForMap, mapAndFormatDynamicValue } from '../../utils/dynamic-data-retrievers';
import { getFooterLabel } from './pacific-availability.common';

export const PACIFIC_SUMMARY_COMMON = {
  27: {
    // 27 - Property Address
    displayFn: (record: ReportRecord, options, ...args) => {
      const finalArgs = sortAttributesByFieldId(options.locale, args, 27);
      const values = finalArgs.map(arg => mapAndFormatDynamicValue(record, arg));
      const recordPosition = digger(record, 'position') + '. ';
      return recordPosition + concatValuesBy(', ', ...values);
    },
  },
  266: {
    // 266 - Summary Map Base64 Image
    displayFn: (record: ReportRecord, options) => {
      const { httpClient, reportExportViewService, reportOptions } = options;
      // remove port number from url
      const portNumberIndex = reportExportViewService.baseUrl.lastIndexOf(':');
      const baseURL = reportExportViewService.baseUrl.substring(0, portNumberIndex);
      const uri = '/api/download/miq/export/capture';
      const { expires_in, userid_token, userInfo, localeId } = getTokensFromLocalStorage();
      const payload = {
        preloadUrl: `${baseURL}/assets/svg/cbre-logo.svg`,
        pageUrl: `${baseURL}/pdf/map/${options.reportId}?isGroupByProperty=` + reportOptions.groupByBuilding,
        waitForSelector: ["miq-summary-map[map-state='load']"],
        viewPort: getWidthAndHeightForMap(options.templateId),
        selector: null,
        localStorageData: { expires_in, userid_token, userInfo, localeId },
      };
      return httpClient.post(uri, payload).pipe(
        map((data: any) => {
          return `data: image/png;base64,${data}`;
        })
      );
    },
  },
  ...getFooterLabel(),
};
